module.exports = __webpack_public_path__ + "static/media/999391.bbaf6ac6.png";